import React from 'react';

import Input from 'components/shared/Input/Input';

const PhysicalAssetKindTerminal = ({ formik }) => {
  return (
    <>
      <Input
        label="Terminal ID"
        isOptional
        data-qa="physical-asset-kind-terminal-terminal-id"
        name="data.terminalId"
        type="text"
        value={formik.values.data.terminalId}
        onChange={formik && formik?.handleChange}
      />
      <Input
        label="Terminal Bluetooth passkey"
        data-qa="physical-asset-kind-terminal-terminal-bt-passkey"
        name="data.terminalBtPasskey"
        type="text"
        isOptional
        value={formik.values.data.terminalBtPasskey}
        onChange={formik && formik?.handleChange}
      />
      <Input
        label="Asset tag"
        data-qa="physical-asset-kind-terminal-asset-tag"
        name="asset_tag"
        type="text"
        isOptional
        value={formik.values.asset_tag}
        onChange={formik && formik?.handleChange}
      />
      <Input
        label="Notes"
        data-qa="physical-asset-notes"
        name="data.notes"
        type="text"
        isOptional
        value={formik.values.data.notes}
        onChange={formik && formik?.handleChange}
      />
    </>
  );
};

export default PhysicalAssetKindTerminal;
